import Link from "next/link";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import Image from "@/components/image";
import { richContentOptions } from "@/components/content-options";

export default function SplitImage({ fields, sys, includes, ...rest }) {
  return (
    <>
      <div className="relative bg-brand-700">
        <div className="h-56 bg-brand-600 sm:h-72 md:absolute md:left-0 md:h-full md:w-1/2">
          {fields.image && (
            <Image
              className="w-full h-full object-cover"
              fields={fields.image}
              fill
              alt={fields.title || ""}
            />
          )}
        </div>
        <div className="absolute inset-0 bg-black opacity-40 md:hidden" />
        <div className="relative max-w-7xl mx-auto px-4 py-12 sm:px-6 lg:px-8 lg:py-16">
          <div className="md:ml-auto md:w-1/2 md:pl-10">
            {fields.subtitle && (
              <h4 className="text-base font-medium uppercase tracking-wider text-gray-300">
                {fields.subtitle}
              </h4>
            )}
            {fields.title && (
              <h3 className="mt-2 text-white font-sans text-3xl font-semibold sm:text-4xl">
                {fields.title}
              </h3>
            )}
            {fields.content && (
              <div className="mt-3 text-lg text-white space-y-4">
                {documentToReactComponents(fields.content, richContentOptions)}
              </div>
            )}
            {fields.ctAs && (
              <div className="mt-8 flex flex-wrap">
                {fields.ctAs.map((cta) => (
                  <Link
                    href={cta.fields.link}
                    key={cta.sys.id}
                    className="mt-8 bg-white border border-transparent rounded-md shadow px-6 py-3 inline-flex items-center text-base font-medium text-brand-600 hover:bg-brand-50 mr-8"
                  >
                    {cta.fields.text}
                  </Link>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
